import React from "react";
import { connect } from "react-redux";
import {
  mapDispatchToProps,
  mapStateToProps,
} from "../../common/UserDataReducer";
import LeftSection from "../../components/Request/LeftSection/LeftSection";
import RightSection from "../../components/Request/RightSection/RightSection";
import "./Request.scss";
function Request() {
  return (
    <main className="new-design-v1 request-main-container" id="style-scroll">
      <section className="left-section">
        <LeftSection />
      </section>
      <section className="right-section">
        <RightSection />
      </section>
    </main>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Request);
